/* New-arrivals sign-up slide-in (snippets/tc-signup-popup.liquid).
   Shows once per browser session (never on a second page), after the set delay (default 15s) and once the
   cookie banner is answered. Never again for anyone who closed it or signed up (here, in the footer, or by ticking
   email consent on an enquiry). The submit itself is handled by tc-enquiry.js (Make + Shopify form). */
(() => {
  const box = document.querySelector('[data-tc-signup]');
  const KEY = 'tc-signup';
  const SESSION_KEY = 'tc-signup-seen';
  const store = {
    get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } },
    set(v) { try { localStorage.setItem(KEY, JSON.stringify({ ...this.get(), ...v })); } catch (e) {} },
  };
  const session = {
    seen() { try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; } },
    mark() { try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {} },
  };

  // Anyone who subscribes elsewhere on the site never sees the pop-up
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (f.matches('[data-tc-newsletter]') && f.querySelector('input[type=email]')?.value) store.set({ subscribed: Date.now() });
    else if (f.matches('[data-tc-form]') && f.querySelector('[data-tc-consent="email"]')?.checked) store.set({ subscribed: Date.now() });
  }, true);
  if (/customer_posted=true/.test(location.search)) store.set({ subscribed: Date.now() });

  if (!box) return;
  const form = box.querySelector('form');
  const state = store.get();
  if (state.subscribed || state.closed || session.seen()) return;
  if (/customer_posted|contact_posted/.test(location.search)) return;

  let shown = false;
  let retry;
  // Shopify's cookie banner sits on the same bottom edge: wait until it has been answered
  const bannerUp = () => {
    const el = document.getElementById('shopify-pc__banner');
    return !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  };
  const show = () => {
    if (shown) return;
    if (document.querySelector('dialog[open]') || bannerUp()) {
      clearTimeout(retry);
      retry = setTimeout(show, 4000);
      return;
    }
    shown = true;
    session.mark();
    box.hidden = false;
    requestAnimationFrame(() => box.classList.add('is-open'));
    cleanup();
  };
  const hide = (remember) => {
    box.classList.remove('is-open');
    setTimeout(() => { box.hidden = true; }, 250);
    if (remember) store.set({ closed: Date.now() });
  };

  const delay = Math.max(5, Number(box.dataset.delay) || 15) * 1000;
  const timer = setTimeout(show, delay);
  function cleanup() { clearTimeout(timer); clearTimeout(retry); }
  document.addEventListener('visitorConsentCollected', () => { if (!shown) { clearTimeout(retry); retry = setTimeout(show, 3000); } });

  box.querySelector('[data-tc-signup-close]')?.addEventListener('click', () => hide(true));
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && shown && !box.hidden && !document.querySelector('dialog[open]')) hide(true); });

  // Interest choice becomes a customer tag on the Shopify form (Make gets it as "Interest" too)
  const tags = box.querySelector('[data-tc-signup-tags]');
  const interest = box.querySelector('[data-tc-signup-interest]');
  const slug = (v) => v.toLowerCase().normalize('NFKD').replace(/[^\w\s-]/g, '').trim().replace(/[\s_]+/g, '-').replace(/-+/g, '-');
  interest?.addEventListener('change', () => {
    tags.value = ['newsletter', 'popup-signup', interest.value && `interest-${slug(interest.value)}`].filter(Boolean).join(',');
  });

  // tc-enquiry.js pauses the first submit to send to Make, then resubmits natively (into the hidden iframe).
  // The resubmit is the one that reaches here unprevented: show the thank-you state.
  form?.addEventListener('submit', (e) => {
    // With a Make webhook set, only the second (native) submit counts; the details already reached Make.
    if (form.dataset.endpoint && !form.dataset.tcSent) return;
    store.set({ subscribed: Date.now() });
    box.querySelector('[data-tc-signup-body]').hidden = true;
    const done = box.querySelector('[data-tc-signup-done]');
    done.hidden = false;
    done.focus({ preventScroll: true });
    setTimeout(() => hide(false), 6000);
  });
})();
